import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { GET_ME_MENUS_API } from "@apis/apiPath";

const useNavigationApi = () => {
	const Ajax = useAjax();

	const getMeMenusApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_ME_MENUS_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getMeMenusApi,
	};
};

export default useNavigationApi;
